@if (progressService.isLoading()) {
    <du-config-detail-skeleton></du-config-detail-skeleton>
} @else {
    <du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.APP_SETTINGS]}">
        <detail-header>
            <div class="header-left">
                @if (logoUrl && logoUrl.length > 0) {
                    <img [ngSrc]="logoUrl" alt="{{ setting?.applicationName }} logo" width="64" height="64"
                         priority>
                }

                <div>
                    <h1 class="detail-header-title">{{ setting?.applicationName }}</h1>
                </div>
            </div>
        </detail-header>
        <detail-body>
            <p-card class="app-settings-detail-card">
                    @if (setting) {
                        <form class="form-container">
                            <div class="field">
                                <label>{{ 'appSettings.application' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.applicationName" name="applicationName">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.identification' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.identification" name="identification">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.tenantName' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.tenantName" name="tenantName">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.participantId' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.participantId" name="participantId">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.participantPartnerId' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.participantPartnerId" name="participantPartnerId">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.relationType' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.relationType" name="relationType">
                            </div>
                            <div class="field">
                                <label>{{ 'appSettings.applicationType' | translate }}</label>
                                <input pInputText [(ngModel)]="setting.applicationType" name="applicationType">
                            </div>
                            <div class="active-container">
                                <p-toggleswitch [(ngModel)]="setting.active" name="active" inputId="active-toggle"/>
                                <label for="active-toggle">{{ 'appSettings.active' | translate }}</label>
                            </div>
                        </form>

                        <div class="editor-container">
                            <div class="editor-header">
                                <i class="pi pi-code"></i>
                                <span>{{ 'appSettings.jsonSettings' | translate }}</span>
                            </div>
                            <div class="editor">
                                <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="code"></ngx-monaco-editor>
                            </div>
                        </div>
                        <div class="editor-actions">
                            <p-button severity="secondary" (click)="resetAppSettings()">
                                <i class="pi pi-refresh"></i>
                                {{ 'button.reset' | translate | uppercase }}
                            </p-button>
                            <p-button (click)="saveAppSettings()">
                                <i class="pi pi-save"></i>
                                {{ 'button.save' | translate | uppercase }}
                            </p-button>
                        </div>
                    }
            </p-card>
        </detail-body>
    </du-config-detail>
}
